// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"25ec3eb5","451":"f54f1567","453":"7e04b87a","455":"d00b2247","592":"b7f0ea65","977":"d48e369b"}[chunkId] + ".chunk.js";
};